import { render, staticRenderFns } from "./AlertPopup.vue?vue&type=template&id=744c89da&scoped=true"
import script from "./AlertPopup.vue?vue&type=script&lang=js"
export * from "./AlertPopup.vue?vue&type=script&lang=js"
import style0 from "./AlertPopup.vue?vue&type=style&index=0&id=744c89da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744c89da",
  null
  
)

export default component.exports